<template>
    <!-- has-cards -->
    <footer class="footer">
        <div class="container">
            <div class="container_fluid">
                <h1>{{ $t('footer.first') }}<span style="color: #233dd2;">{{ $t('footer.pay') }}</span></h1>
                <div class="container_fluid_box">
                    <div class="fluid_box_one row">
                        <div class="col-3" v-for="(value, index) in list" :key="index">
                            <router-link :to="value.href">
                                <h6>{{ value.title }} </h6>
                            </router-link>
                            <div class="d-flex flex-column mt-3">
                                <router-link :to="item.href" class="text-default" v-for="(item, inx) in value.children"
                                    :key="inx">
                                    <p style="margin: 0;">{{ item.title }} </p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="fluid_box_one row">
                        <div class="col-3" v-for="(value, index) in list2" :key="index">
                            <router-link :to="value.href">
                                <h6>{{ value.title }} </h6>
                            </router-link>
                        </div>
                    </div>
                    <div class="fluid_box_one row">
                        <div class="col-3" v-for="(value, index) in list3" :key="index">
                            <router-link :to="value.href">
                                <h6>{{ value.title }}</h6>
                            </router-link>
                            <div class="d-flex flex-column mt-3">
                                <p style="margin: 0;" class="text-default">{{ value.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container_last">
                <hr>
                <div class="row align-items-center justify-content-md-between">
                    <div class=" col-5">
                        <div class="copyright">
                            &copy; {{ year }}
                            <a href="javascript:;" rel="noopener">Lanton Pay</a>
                        </div>
                    </div>
                    <div class=" col-7">
                        <ul class="nav nav-footer justify-content-end">
                            <li class="nav-item">
                                <a href="#/link/agreement" class="nav-link" target="_blank" rel="noopener">{{
                                    $t('footer.link') }}</a>
                            </li>
                            <li class="nav-item">
                                <a href="#/link/privacy" class="nav-link" target="_blank" rel="noopener">{{
                                    $t('footer.link1') }}</a>
                            </li>
                            <li class="nav-item">
                                <a href="#/link/disclaimer" class="nav-link" target="_blank" rel="noopener">{{
                                    $t('footer.link2') }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    name: 'app-footer',
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    computed: {
        list() {
            return [
                {
                    title: this.$t('network.title'),
                    href: '/network',
                    children: [
                        {
                            title: this.$t('cost.title'),
                            href: '/cost'
                        },
                        {
                            title: this.$t('bill.title'),
                            href: '/bill'
                        }
                    ]
                },
                {
                    title: this.$t('currency.title'),
                    href: '/currency',
                    children: [
                        {
                            title: this.$t('settlement.title'),
                            href: '/settlement'
                        },
                        {
                            title: this.$t('exchange.title'),
                            href: '/exchange'
                        }
                    ]
                },
                {
                    title: this.$t('plan.title'),
                    href: '/plan',
                    children: [
                        {
                            title: this.$t('enterprise.title'),
                            href: '/enterprise'
                        },
                        {
                            title: this.$t('account.title'),
                            href: '/account'
                        }
                    ]
                },
                {
                    title: this.$t('security.title'),
                    href: '/security',
                    children: [
                        {
                            title: this.$t('organization.title'),
                            href: '/organization'
                        },
                        {
                            title: this.$t('fund.title'),
                            href: '/fund'
                        }
                    ]
                },
            ];
        },
        list2() {
            return [
                {
                    title: this.$t('travel.title'),
                    href: '/number/1'
                },
                {
                    title: this.$t('life.title'),
                    href: '/number/4'
                },
                {
                    title: this.$t('entertainment.title'),
                    href: '/number/7'
                },
                {
                    title: this.$t('journey.title'),
                    href: '/number/10'
                },
            ]
        },
        list3() {
            return [
                {
                    title: this.$t('about.title'),
                    href: '/about/0',
                    description: this.$t('about.blurb'),
                },
                {
                    title: this.$t('cooperation.title'),
                    href: '/about/3',
                    description: this.$t('cooperation.blurb'),
                },
                {
                    title: this.$t('license.title'),
                    href: '/about/5',
                    description: this.$t('license.blurb'),
                },
            ]
        }
    }
};
</script>
<style scoped lang="scss">
.footer {
    height: var(--main-height);
    padding-top: 4em;
    padding-bottom: 2em;
    background-color: white;
    box-sizing: border-box;
    .container {
        height: 100%;
        display: flex;
        flex-direction: column;

        .container_fluid {
            flex: 1;
            padding-top: 30px;
            display: flex;
            flex-direction: column;

            h1 {
                font-weight: 700;
            }

            .container_fluid_box {
                margin-top: 50px;
                display: flex;
                flex-direction: column;
                gap: 2.25rem;
                justify-content: flex-start;

                .fluid_box_one {
                    margin: 0;

                    .d-flex.flex-column {
                        gap: 0.5rem;
                    }

                    .col-3 {
                        p.text-default {
                            line-height: 1.65;
                        }

                        // PC端：四段展示 (col-3 表示 25% 宽度)
                        @media (max-width: 768px) {
                            // 手机端：两段展示 (col-6 表示 50% 宽度)
                            flex: 0 0 50%;
                            max-width: 50%;
                        }
                        
                        @media (max-width: 576px) {
                            // 更小的手机屏幕：两段展示，增加间距
                            flex: 0 0 50%;
                            max-width: 50%;
                            margin-bottom: 1rem;
                        }
                    }
                }
            }
        }
    }
    .container_last {
        // padding-bottom: 20px;
    }
    .nav-link {
        padding: 0.25rem 0.5rem;
    }
    .col-3 {
        padding: 0;
    }
}
</style>
